import { type Common } from '../common.js';
import { type Permission } from '../models/group.js';
import {
  type BaseUserGroup,
  type UserGroup,
  type UserGroupWithDetails,
} from '../models/user/group.js';

export class API {
  baseEndpoint = '/user-groups';
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(toAdd: BaseUserGroup, ticketUrl?: string): Promise<UserGroup> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, { ...toAdd, ticketUrl });
  }

  async createBulk(args: {
    userId: string;
    groupIds: string[];
    ticketUrl?: string;
  }): Promise<UserGroup[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/bulk`);
    return await this.common.postJSON(url, args);
  }

  async remove(id: string, ticketUrl?: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}?ticketUrl=${ticketUrl}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }

  async findMyUserGroups(): Promise<UserGroupWithDetails[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/me`);
    const { userGroups } = await this.common.getJSON(url);
    return userGroups;
  }

  async myPermissions(): Promise<Permission[]> {
    const groups = await this.findMyUserGroups();
    return groups.map((g) => g.permissions).reduce((accum, perms) => [...accum, ...perms], []);
  }
}
